import React, { useState, useEffect } from "react";
import withDashboard from "../../HOC/withDashboard";
import BackgroundImage from "../../assets/profilebackground.jpeg";
import "../Profile/index.css";
import { Button, TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  createCustomReferralCode,
  updateCustomReferralCode,
  getByIdCustomReferralCode,
} from "../../redux/actions/customReferralAction";
import Loader from "../../components/Loader";
import { useNavigate, useParams } from "react-router-dom";

const ReferralCodeForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const [isLoading, setIsLoading] = React.useState(false);

  const isEdit = Boolean(id);
  const [form, setForm] = useState({
    name: "",
    code: "",
  });
  const [errors, setErrors] = useState({
    name: false,
    code: false,
  });

  useEffect(() => {
    if (isEdit) {
      const fetchData = async () => {
        const response = await dispatch(getByIdCustomReferralCode(id));
        // If your action returns a payload, extract it accordingly
        console.log({ response });

        if (response && response.code) {
          setForm(response.code);
          setIsLoading(false);
        }
      };
      fetchData();
    }
  }, [isEdit]);

  const onChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: false });
  };

  const onSubmit = () => {
    let newErrors = {
      name: !form.name,
      code: !form.code,
    };
    setErrors(newErrors);
    if (Object.values(newErrors).some((v) => v)) return;
    if (isEdit) {
      dispatch(
        updateCustomReferralCode(id, {
          data: { _id: id, ...form },
          onSuccess: () => navigate("/CustomReferralCode"),
        })
      );
    } else {
      dispatch(
        createCustomReferralCode({
          data: form,
          onSuccess: () => navigate("/CustomReferralCode"),
        })
      );
    }
  };

  return (
    <div className="profile-container">
      <div className="profile-backgroundImage-container">
        <img
          src={BackgroundImage}
          className="profile-backgroundImage"
          alt="background.png"
        />
      </div>
      <div className="profile-card-container">
        <div className="profile-card">
          <h2 style={{ marginBottom: 24 }}>
            {isEdit ? "Edit" : "Add"} Custom Referral Code
          </h2>
          <div className="profile-inputs-container">
            <div className="profile-input-row">
              <div className="profile-input-item">
                <div className="profile-input-container">
                  <TextField
                    label="Name"
                    variant="outlined"
                    className="w-100"
                    name="name"
                    onChange={onChange}
                    value={form.name}
                    error={errors.name}
                    helperText={errors.name ? "Name is required" : ""}
                  />
                </div>
              </div>
              <div className="profile-input-item">
                <div className="profile-input-container">
                  <TextField
                    label="Referral Code"
                    variant="outlined"
                    className="w-100"
                    name="code"
                    onChange={onChange}
                    value={form.code}
                    error={errors.code}
                    helperText={errors.code ? "Referral code is required" : ""}
                  />
                </div>
              </div>
            </div>
            <div className="profile-input-btn-container">
              <Button
                variant="contained"
                className="profile-btn"
                onClick={onSubmit}
                disabled={isLoading}
              >
                {isEdit ? "Update" : "Add"} Referral Code
              </Button>
              <Button
                variant="outlined"
                style={{ marginLeft: 16 }}
                onClick={() => navigate("/CustomReferralCode")}
              >
                Cancel
              </Button>
            </div>
          </div>
          {isLoading && <Loader />}
        </div>
      </div>
    </div>
  );
};

export default withDashboard(ReferralCodeForm);
